import { ADD, ADDTOCART, LESS } from "./actionType";

const initialproduct = [
  {
    name: "Asus Vivobook X515MA",
    quantity: 20,
    price: 35500,
    id: 1,
    cartQuantity: 1,
    stockOut: false,
  },
  {
    name: "Dell E1916HV 18.5 Inch",
    quantity: 35,
    price: 9300,
    id: 2,
    cartQuantity: 1,
    stockOut: false,
  },
  {
    name: "Canon Eos 4000D 18MP",
    quantity: 72,
    price: 36500,
    id: 3,
    cartQuantity: 1,
    stockOut: false,
  },
];

const productReducer = (state = initialproduct, action) => {
  function other(item) {
    return item.id === action.payload.id;
  }
  switch (action.type) {
    case ADDTOCART:
      const finding = initialproduct.find(other);

      if (finding.quantity === 0) {
        finding.stockOut = true;
      } else {
        finding.quantity -= 1;
        finding.stockOut = false;
      }

      return state;

    case ADD:
      if (action.payload.quantity === 0) {
        action.payload.stockOut = true;
      } else {
        action.payload.quantity -= 1;
        action.payload.stockOut = false;
      }

      return state;
    case LESS:
      action.payload.quantity += 1;

      return state;
    default:
      return state;
  }
};

export default productReducer;
